// extracted by mini-css-extract-plugin
export default {"container":"styles-module__container--UCezf"};